/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { getTiposProfesion } from "../../../services/ParametrosService";

const initialState = {
  descripcion: "",
  matricula: "",
};

const tableColumns = (handleObtieneProfesion) => [
  {
    name: "id",
    label: "ID",
    options: {
      filter: false,
      sort: false,
      display: "excluded",
    },
  },
  {
    name: "descripcion",
    label: "Profesión",
    options: {
      filter: false,
      sort: false,
    },
    setCellProps: () => ({
      style: {
        textAlign: 'center',
      },
    }),
    setCellHeaderProps: () => ({
      style: {
        textAlign: 'center',
      },
    })

  },
  {
    name: "matricula",
    label: "Número de matrícula",
    options: {
      filter: false,
      sort: false,
    },
    setCellProps: () => ({
      style: {
        textAlign: 'center',
      },
    }),
    setCellHeaderProps: () => ({
      style: {
        textAlign: 'center',
      },
    }),

  },
  {
    name: "actions",
    label: "Acciones",
    options: {
      filter: false,
      sort: false,
      empty: true,
      setCellProps: () => ({
        style: {
          textAlign: 'center',
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          textAlign: 'center',
        },
      }),
      customBodyRenderLite: (dataIndex) => (
        <>
          <Tooltip title="Ver Profesión">
            <IconButton
              size="small"
              aria-label="view"
              onClick={() => handleObtieneProfesion(dataIndex)}
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  },
];

const tableOptions = {
  download: false,
  filter: false,
  print: false,
  search: false,
  viewColumns: false,
  pagination: false,
  elevation: 1,
  selectableRows: "none",
  textLabels: {
    body: {
      noMatch: "No se encontraron registros",
    },
  },
};

const nameItemText = "profesiones";
const itemGender = "M";

const ProfesionesDialog = ({
  onSave,
  onClose,
  itemCrud,
  itemsCrud,
  actionCrud,
  setMessage,
  setShowMessage
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [profesiones, setProfesiones] = useState([]);
  const [tiposProfesion, setTiposProfesion] = useState([]);
  const [valueAutoCompleteTipoProfesion, setValueAutoCompleteTipoProfesion] = useState(null);
  const [inputValueAutoCompleteTipoProfesion, setInputValueAutoCompleteTipoProfesion] = useState("");


  
  useEffect(() => {
    loadTiposProfesion();
    if (actionCrud === "create") {
      setItemCrudLocal(initialState);
    } else {
      setItemCrudLocal(itemCrud);
    }
    let _itemCrud = itemCrud;
    _itemCrud = itemCrud
    setProfesiones(_itemCrud);

  }, [actionCrud, itemCrud, itemsCrud]);

  const handleObtieneProfesion = (dataIndex) => {
    const selectedProfesion = profesiones[dataIndex];
    setItemCrudLocal({
      descripcion: selectedProfesion.descripcion,
      matricula: selectedProfesion.matricula,
    });

  };

  const handleCloseDialog = () => {
    onClose();
  };

  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  const handleSave = () => {
    if (itemCrudLocal.descripcion === "" || itemCrudLocal.matricula === "") {
      setMessage({
        severity: "error",
        messageText: "Debes completar todos los campos.",
      });
      setShowMessage(true);
      return;
    }
    save();
  };

  const save = async () => {
    const _itemCrud = {
      id: _idDocumento,
      descripcion: itemCrudLocal.tipo,
      matricula: itemCrudLocal.matricula,
    };

    // const response = await saveDocumento(actionCrud, _itemCrud); 

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };

  // obtener tipos de profesiones

  const loadTiposProfesion = async () => {
    const response = await getTiposProfesion();
    if (response.ok) {
      const _response = response.data[0].data
      console.log('loadTiposProfesion - _response: ');
      console.log(_response);
      setTiposProfesion(_response);
    }
  }



  return (
    <Dialog
      open={true}
      onClose={handleCloseDialog}
      maxWidth="md"
      fullWidth={true}
      scroll="paper"
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">
        {actionCrud === "view" ? "Ver" : "Nuevo"} {nameItemText}
        <IconButton
          aria-label="close"
          onClick={handleCloseDialog}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Box sx={{ m: 1, p: 1 }}>
          <Grid container spacing={2}>

            {/*
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  fullWidth
                  sx={{ mb: 1, width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                    readOnly: actionCrud === 'view'
                  }}
                  id="descripcion"
                  label="Profesión"
                  variant="outlined"
                  size="small"
                  name="descripcion"
                  value={itemCrudLocal.descripcion?.toUpperCase() || ""}
                  onChange={handleChange}
                />
              </Grid>
            */}
            
           


              <Grid item xs={12} md={6} lg={6}>
                <FormControl fullWidth sx={{ mb: 1 }}>
                  <Autocomplete
                    value={valueAutoCompleteTipoProfesion}
                    onChange={(event, newValue) => {
                      setValueAutoCompleteTipoProfesion(newValue);
                    }}
                    inputValue={inputValueAutoCompleteTipoProfesion}
                    onInputChange={(event, newInputValue) => {
                      setInputValueAutoCompleteTipoProfesion(newInputValue);
                    }}
                    id="tipoProfesion"
                    options={tiposProfesion}
                    getOptionLabel={(option) => (option.descripcion).toUpperCase()}
                    renderInput={(params) => 
                      <TextField
                      {...params} 
                      label="Tipo de Profesión" 
                      size="small"
                      />
                    }
                    ListboxProps={{ style: { maxHeight: "300px" } }}
                    disableClearable={true}
                  />
                </FormControl>
              </Grid>
            
            <Grid item xs={3} lg={3}>
              <TextField
                fullWidth
                sx={{ mb: 1 }}
                inputProps={{
                  autoComplete: "off",
                  readOnly: actionCrud === 'view'
                }}
                id="matricula"
                label="Número de matrícula"
                variant="outlined"
                size="small"
                name="matricula"
                value={itemCrudLocal.matricula}
                onChange={handleChange}
              />
            </Grid>
          </Grid>
        </Box>

        <MUIDataTable
          title={"Listado de profesiones"}
          columns={tableColumns(handleObtieneProfesion)}
          options={tableOptions}
          data={profesiones? profesiones : []}
        />
        <Box sx={{ textAlign: "right", mb: 2, mt: 2 }}>
          {actionCrud !== "view" && (
            <Button
              sx={{ mr: 1 }}
              variant="contained"
              onClick={handleSave}
              startIcon={<SaveIcon />}
            >
              Guardar
            </Button>
          )}
          <Button sx={{ mr: 1 }} variant="outlined" onClick={handleCloseDialog}>
            {actionCrud === "view" ? "Volver" : "Cancelar"}
          </Button>
        </Box>
      </DialogContent>


    </Dialog>
  );
};

export default ProfesionesDialog;
